import { z } from 'zod';

/** Двойник: 10–20 фото одного человека + проверка живости (поворот головы). */
export const TWIN_MIN_PHOTOS = 10;
export const TWIN_MAX_PHOTOS = 20;
/** Сколько лучших фото двойника идут референсами в генерацию. */
export const TWIN_REFS = 4;
export const LIVENESS_POSES = ['front', 'left', 'right'] as const;
export type LivenessPose = (typeof LIVENESS_POSES)[number];

export const TWIN_PHOTO_REJECTS = {
  no_face: 'Не нашли лицо',
  many_faces: 'На фото несколько лиц — нужно одно',
  small_face: 'Лицо слишком мелкое — подойди ближе',
  blurry: 'Лицо нечёткое',
  other_person: 'Похоже, это другой человек',
  minor: 'Похоже, на фото ребёнок — двойник делается только из твоих фото',
} as const;
export type TwinPhotoReject = keyof typeof TWIN_PHOTO_REJECTS;

export const twinPhotoSchema = z.object({
  id: z.string().uuid(),
  ok: z.boolean(),
  reason: z.string().nullable(),
  createdAt: z.string(),
});
export type TwinPhoto = z.infer<typeof twinPhotoSchema>;

export const twinSchema = z.object({
  /** none — не начинали; photos — собираем фото; liveness — проверка живости; ready — готов. */
  status: z.enum(['none', 'photos', 'liveness', 'ready']),
  photos: z.array(twinPhotoSchema),
  okPhotos: z.number().int(),
  minPhotos: z.number().int(),
  maxPhotos: z.number().int(),
  /** Насколько фото похожи между собой, 0–100. */
  consistency: z.number().int().nullable(),
  liveness: z.object({ front: z.boolean(), left: z.boolean(), right: z.boolean() }),
  readyAt: z.string().nullable(),
  /** Сервис сверки лиц доступен. */
  available: z.boolean(),
});
export type Twin = z.infer<typeof twinSchema>;

export const livenessResultSchema = z.object({
  pose: z.enum(LIVENESS_POSES),
  ok: z.boolean(),
  /** Подсказка, если не прошло. */
  hint: z.string().nullable(),
  twin: twinSchema,
});
export type LivenessResult = z.infer<typeof livenessResultSchema>;
